// The draw export banner — the image in the footer of the Excel main-draw export (Competitions →
// Draw → Export). It is NOT the partner band: the band is composed from the partners above, the
// export takes one hand-made wide image. Changing partners does not change it, and this file is
// everything CP knows about it.
//
// The API stores `exportBanner { filename, updatedAt, updatedBy }` in settings. CP sends only the
// filename the upload answered with; who and when are stamped by the API from the session.

// Where the image is uploaded. The gateway reads it from the same folder, and gates writes to the
// `common` bucket to admin/superAdmin.
export const EXPORT_BANNER_BUCKET = "common"
export const EXPORT_BANNER_FOLDER = "exports"
export const EXPORT_BANNER_PATH = `${EXPORT_BANNER_BUCKET}/${EXPORT_BANNER_FOLDER}`

/**
 * The admin read answers `{ banner, path, defaultPath }`: the stored record (or null), and the
 * path under /assets the export is using right now — the upload, or the shipped sponsors.png.
 * Anything else (an old API, an empty body) reads as "nothing uploaded yet".
 */
export const readExportBanner = response => {
  const data = response?.data
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return { banner: null, path: "" }
  }
  const banner =
    data.banner && typeof data.banner === "object" && data.banner.filename
      ? {
          filename: String(data.banner.filename),
          updatedAt: data.banner.updatedAt || null,
          updatedBy: data.banner.updatedBy || null,
        }
      : null
  return { banner, path: typeof data.path === "string" ? data.path : "" }
}

/** CP's own address for an asset path, same rule as the partner logos. */
export const exportBannerSrc = path => {
  const stored = String(path || "").trim().replace(/^\/+/, "")
  return stored ? `${process.env.REACT_APP_API_URL}/assets/${stored}` : ""
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const two = n => String(n).padStart(2, "0")

/** `23 Aug 2026, 14:05` in the admin's local time — by hand, so it reads the same in every browser. */
export const formatChangedAt = value => {
  if (!value) return ""
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ""
  return `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}, ${two(
    date.getHours()
  )}:${two(date.getMinutes())}`
}

/** "Last changed 23 Aug 2026, 14:05 by admin@sportya.net" — or as much of it as is known. */
export const describeChange = banner => {
  if (!banner) return ""
  const when = formatChangedAt(banner.updatedAt)
  const who = String(banner.updatedBy || "").trim()
  const parts = ["Last changed"]
  if (when) parts.push(when)
  if (who) parts.push(`by ${who}`)
  return parts.length > 1 ? parts.join(" ") : "Last changed — date not recorded"
}
